import { useRef, useState } from "react";

// Bootstrap Modal has a built-in fade on show; the exit animation only fires
// if show toggles false BEFORE the component unmounts. This hook lets each
// modal trigger the fade-out, then runs the caller's onSave/onCancel in the
// onExited callback so the parent can safely unmount the modal.
export function useModalDismiss(onCancel: () => void, onSave?: () => void) {
    const [show, setShow] = useState(true);
    const intent = useRef<"cancel" | "save">("cancel");

    const dismiss = (mode: "cancel" | "save" = "cancel") => {
        intent.current = mode;
        setShow(false);
    };

    const onExited = () => {
        if (intent.current === "save" && onSave) onSave();
        else onCancel();
    };

    return { show, dismiss, onExited };
}
